var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("section-title", {
          attrs: { "has-line": "", title: "Información General" }
        }),
        _c("div", { staticClass: "row ml-2 mb-5" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Vendor Name: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [_vm._v(" " + _vm._s(_vm.value.vendorName) + " ")]
            )
          ]),
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Email ID: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [_vm._v(" " + _vm._s(_vm.value.vendorEmail) + " ")]
            )
          ]),
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Vendor Status: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [_vm._v(" " + _vm._s(_vm.value.vendorStatus) + " ")]
            )
          ]),
          _c(
            "div",
            { staticClass: "col d-flex" },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    i: `fas fa-redo-alt pr-1`,
                    variant: "outline-success align-self-center"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("on-update-vendor")
                    }
                  }
                },
                [_vm._v(" Actualizar Vendor ")]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          [
            _c("icon-view", {
              staticClass: "mb-3",
              attrs: {
                gradient: "",
                icon: "fas fa-map-marker-alt",
                "icon-background": "#FF7058",
                "icon-color": "#fff",
                title: "Direcciones"
              }
            }),
            _vm._l(_vm.value.addresses, function(address, index) {
              return _c(
                "div",
                {
                  key: `address-item-${index}`,
                  staticClass: "bg-secondary-13 rounded p-2 row mb-2 ml-1"
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Address: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(address.addressName) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" City: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(address.city) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" State: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(address.state) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Zip Code: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(address.zipCode) + " ")]
                    )
                  ])
                ]
              )
            }),
            _vm.value.addresses.length == 0
              ? _c("custom-result-not-found")
              : _vm._e()
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "mt-5" },
          [
            _c("icon-view", {
              staticClass: "mb-3",
              attrs: {
                gradient: "",
                icon: "fas fa-phone-alt",
                "icon-background": "#FF7058",
                "icon-color": "#fff",
                title: "Contacto"
              }
            }),
            _vm._l(_vm.value.contacts, function(contact, index) {
              return _c(
                "div",
                {
                  key: `contact-item-${index}`,
                  staticClass: "bg-secondary-13 rounded p-2 row mb-2 ml-1"
                },
                [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Line Number int: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(contact.lineNumber) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Phone Type: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(contact.phoneType) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Country Code: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(contact.countryCode) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Phone: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [_vm._v(" " + _vm._s(contact.phone) + " ")]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Extension: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [
                        _vm._v(
                          " " + _vm._s(_vm._f("empty")(contact.extension)) + " "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Location Description: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "color-black font-16 font-weight-normal" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(contact.locationDescription)
                            ) +
                            " "
                        )
                      ]
                    )
                  ])
                ]
              )
            }),
            _vm.value.contacts.length == 0
              ? _c("custom-result-not-found")
              : _vm._e()
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }